// extracted by mini-css-extract-plugin
export default {"ProfileSettings":"styles_ProfileSettings__Pvrxx","noPaddings":"styles_noPaddings__CU96p","container":"styles_container__1AXFr","title":"styles_title__y8feP"};